export default function ChapterCard({chapter, onClick, unlocksIn, selectedId}) {

    const getCardStyle = () => {
        let style = []
        if (chapter.isLocked) style.push('shaded-neutral')
        else style.push('clickable')
        if (chapter.isCompleted || chapter.isLocked) style.push('outline-card')
        if (chapter.id == selectedId) style.push('filled-accent')
        return style.join(' ')
    }

    const handleClick = () => {
        if (!chapter.isLocked) onClick(chapter)
    }

    return(
        <div className={`card ${getCardStyle()} flex space-between center`} onClick={handleClick}>
            <div>
                <p className={`card-label ${chapter.isCompleted && chapter.id != selectedId ? 'o-50' : 'o-65'}`}>Month {chapter.order} <span className="light">{unlocksIn ? `• Unlocks in ${unlocksIn} Days` : ''}</span></p>
                <p className={`card-title ${chapter.isCompleted && chapter.id != selectedId ? 'regular o-50' : ''}`}>{chapter.title}</p>
                {chapter.id == selectedId && <p className="card-body showing vi-spacer-xxs">{chapter.theme}</p>}
            </div>
            {(chapter.isLocked || chapter.isCompleted) && <span className="material-symbols-outlined scale-m vi-spacer-xxs h-spacer-xs hi-spacer-s o-85">{chapter.isCompleted ? 'select_check_box' : 'lock'}</span>}
        </div>
    )    
}